import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const PAGE_LIMIT = 100
const MAX_PAGES = 50   // safety stop: 5,000 rows

// Walks ?page=1,2,3… until a page is short/empty or adds nothing new (guards an API that
// ignores `page`), and returns every row in the same envelope shape as a single page.
async function fetchAllPages(url: string): Promise<any> {
  const rows: any[] = []
  const seen = new Set<unknown>()
  let first: any
  for (let page = 1; page <= MAX_PAGES; page++) {
    const res = await restClient.get(`${url}?page=${page}&limit=${PAGE_LIMIT}`).then(r => r.data)
    first ??= res
    const list: any[] = Array.isArray(res) ? res : (res?.data ?? [])
    const fresh = list.filter(r => r?.id == null || !seen.has(r.id))
    fresh.forEach(r => r?.id != null && seen.add(r.id))
    rows.push(...fresh)
    const total = Number(res?.total ?? res?.meta?.total ?? res?.pagination?.total ?? NaN)
    if (list.length < PAGE_LIMIT || fresh.length === 0 || (Number.isFinite(total) && rows.length >= total)) break
  }
  return Array.isArray(first) ? rows : { ...first, data: rows }
}

export const roleService = {
  // Every permission, not just the first page.
  getAllPermissions: () => fetchAllPages(endpoints.rolesAndPermission.getPermissions),
  // Admin Roles & Permissions
  getRoles:        (p: { page?: number; limit?: number } = {}) =>
    restClient.get(`${endpoints.rolesAndPermission.getRoles}?page=${p.page??1}&limit=${p.limit??100}`).then(r => r.data),
  getPermissions:  (p: { page?: number; limit?: number } = {}) =>
    restClient.get(`${endpoints.rolesAndPermission.getPermissions}?page=${p.page??1}&limit=${p.limit??100}`).then(r => r.data),
  createRole:      (d: Record<string, unknown>) => restClient.post(endpoints.rolesAndPermission.createRole, d).then(r => r.data),
  createPermission:(d: Record<string, unknown>) => restClient.post(endpoints.rolesAndPermission.createPermission, d).then(r => r.data),
  mapRolePermission:(d: Record<string, unknown>) => restClient.post(endpoints.rolesAndPermission.mapRoleToPermission, d).then(r => r.data),
  listMappedRoles: (p: { page?: number; limit?: number } = {}) =>
    restClient.get(`${endpoints.rolesAndPermission.listMappedRoles}?page=${p.page??1}&limit=${p.limit??100}`).then(r => r.data),
  // School Admin Roles & Permissions
  school: {
    getRoles:        (p: { page?: number; limit?: number } = {}) =>
      restClient.get(`${endpoints.rolesAndPermissionSchoolAdmin.getRoles}?page=${p.page??1}&limit=${p.limit??100}`).then(r => r.data),
    getPermissions:  (p: { page?: number; limit?: number } = {}) =>
      restClient.get(`${endpoints.rolesAndPermissionSchoolAdmin.getPermissions}?page=${p.page??1}&limit=${p.limit??100}`).then(r => r.data),
    createRole:      (d: Record<string, unknown>) => restClient.post(endpoints.rolesAndPermissionSchoolAdmin.createRole, d).then(r => r.data),
    createPermission:(d: Record<string, unknown>) => restClient.post(endpoints.rolesAndPermissionSchoolAdmin.createPermission, d).then(r => r.data),
    mapRolePermission:(d: Record<string, unknown>) => restClient.post(endpoints.rolesAndPermissionSchoolAdmin.mapRoleToPermission, d).then(r => r.data),
    listMappedRoles: (p: { page?: number; limit?: number } = {}) =>
      restClient.get(`${endpoints.rolesAndPermissionSchoolAdmin.listMappedRoles}?page=${p.page??1}&limit=${p.limit??100}`).then(r => r.data),
  },
}
